/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ trialSuffix: NonNullable<unknown> }} Ccsl_Export_Footer_CreatedInputs */



/**
* | output |
* | --- |
* | "Created using Closed Caption Creator 8{trialSuffix}" |
*
* @param {Ccsl_Export_Footer_CreatedInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const ccsl_export_footer_created = /** @type {((inputs: Ccsl_Export_Footer_CreatedInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ccsl_Export_Footer_CreatedInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Cree avec Closed Caption Creator 8${i?.trialSuffix}`)
	if (locale === "de") return /** @type {LocalizedString} */ (`Erstellt mit Closed Caption Creator 8${i?.trialSuffix}`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Creato utilizzando Closed Caption Creator 8${i?.trialSuffix}`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`Создано с помощью программы для создания субтитров Closed Caption Creator 8${i?.trialSuffix}`)
	if (locale === "es") return /** @type {LocalizedString} */ (`Creado con Closed Caption Creator 8${i?.trialSuffix}`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`使用 Closed Caption Creator 8${i?.trialSuffix} 创建`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`クローズドキャプションクリエーター 8${i?.trialSuffix} を使用して作成`)
	if (locale === "hi") return /** @type {LocalizedString} */ (`क्लोज्ड कैप्शन क्रिएटर 8${i?.trialSuffix} का उपयोग करके बनाया गया`)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`Criado usando o Closed Caption Creator 8${i?.trialSuffix}`)
	return /** @type {LocalizedString} */ (`Created using Closed Caption Creator 8${i?.trialSuffix}`)
});